import DocketwiseHome from '@/views/integrations/DocketwiseHome'

export const docketwiseRoutes = {
  path: '/integrations/docketwise',
  name: 'integrationDocketwise',
  meta: { requiresAuth: true },
  component: DocketwiseHome,
  props: true,
  redirect: { name: 'user-account-integration-settings' },
  children: [
    {
      path: 'callback',
      name: 'int-docketwise-callback',
      meta: { requiresAuth: true, callback: true },
      props: true,
      component: _ => import('@/components/Integrations/Docketwise/DocketwiseCallback'),
    },
  ],
}
